module.exports = __webpack_public_path__ + "static/media/compra-segura.edc4f9fe.png";